module.exports = __webpack_public_path__ + "images/switch_off_7a530f512f96cb535e363fe871537735.svg";